'use strict';

var ShowIfFeatureDirective = function ShowIfFeatureDirective(featureToggleService) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 999,
    link: function link(scope, element, attrs, ctrl, $transclude) {
      var featureName = attrs.rmShowIfFeature;
      if (featureToggleService.isEnabled(featureName)) {
        $transclude(scope.$new(), function (clone) {
          element.after(clone).remove();
        });
      }
    }
  };
};
ShowIfFeatureDirective.$inject = ['FeatureToggleService'];
module.exports = ShowIfFeatureDirective;